import { useCastController } from '../../../chromecast/hooks/use-cast-controller';

interface ChromecastPosterProps {
  src: string;
}

export function ChromecastPoster({ src }: ChromecastPosterProps) {
  const controller = useCastController();

  return (
    <div className="image-container" onClick={() => controller.playOrPause()}>
      <img className="chromecast" alt="chromecast" src={src} />
    </div>
  );
}
